import { render, staticRenderFns } from "./Importing.vue?vue&type=template&id=6200190e&scoped=true"
import script from "./Importing.vue?vue&type=script&lang=ts"
export * from "./Importing.vue?vue&type=script&lang=ts"
import style0 from "./Importing.vue?vue&type=style&index=0&id=6200190e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6200190e",
  null
  
)

export default component.exports